module.exports = __webpack_public_path__ + "static/media/projects_image.a619820f.svg";